"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Write a {@link PartialJSONImpl} update constraint to the stream
 */
function write(bos, value) {
    Codec.writeObject(bos, value.getWithValues(), Codec.writeString, function (o, bytes) {
        Codec.writeBytes(o, bytes.asBuffer());
    });
    Codec.writeCollection(bos, Array.from(value.getWithoutValues()), Codec.writeString);
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/partial-json-serialiser.js
// module id = 1678
// module chunks = 1